export default function ProvidersTable() {
  let tableWrapper
  let buttonWrapper
  let subHeading

  const init = () => {
    tableWrapper = $('.js-providers-page__table')
    buttonWrapper = $('.js-providers-page__filters')
    subHeading = $('.js-providers-page__heading')

    if (buttonWrapper.length > 0) {
      getURLParams()
      initButtonClicks()
    }
  }

  const getURLParams = () => {
    let urlParams = new URLSearchParams(window.location.search)
    let selectedCategory

    if (urlParams.has('category')) {
      selectedCategory = urlParams.get('category')
    } else {
      selectedCategory = tableWrapper.data('default-category')
    }

    setContent(selectedCategory)
  }

  const initButtonClicks = () => {
    buttonWrapper.find('.js-providers-page__button').on('click', (e) => {
      let selectedCategory = $(e.target).data('category')

      setContent(selectedCategory)
    })
  }

  const setContent = (selectedCategory) => {
    let buttons = buttonWrapper.find('.js-providers-page__button')
    let rows = $('.c-provider')
    let categoryTitle

    $.each(buttons, function() {
      $(this).addClass('c-button--secondary')

      if ($(this).data('category') == selectedCategory) {
        $(this).removeClass('c-button--secondary')
        categoryTitle = $(this).html()
      }
    })

    subHeading.html(categoryTitle)

    let count = 0

    $.each(rows, function() {
      $(this).addClass('c-provider--hide')

      if ($(this).hasClass(selectedCategory)) {
        $(this).removeClass('c-provider--hide')
        count++
      }
    })

    if (count == 0) {
      $('.c-providers-page__empty-message').show()
    } else {
      $('.c-providers-page__empty-message').hide()
    }

    const url = new URL(window.location);
    url.searchParams.set('category', selectedCategory);
    window.history.pushState({}, '', url);
  }

  return {
    init: init,
  }
}

$(function () {
  try {
    ProvidersTable().init()
  } catch (error) {
    console.error(error)
  }
})
